import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=8c0c15fc&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c0c15fc')) {
      api.createRecord('8c0c15fc', component.options)
    } else {
      api.reload('8c0c15fc', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=8c0c15fc&", function () {
      api.rerender('8c0c15fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23Fsngc5EpV7S/JS/comp/IncreaseNumber.vue"
export default component.exports